import { DATE_PLUS13, DATE_PLUS30 } from '../const';
export const getMinMaxDate = (dateInfo) => {
    const minDate = dateInfo.additionalFields?.find((field) => field.fieldName === DATE_PLUS13)?.fieldValue;
    const maxDate = dateInfo.additionalFields?.find((field) => field.fieldName === DATE_PLUS30)?.fieldValue;
    return {
        minDate,
        maxDate,
    };
};
